PJQ.views.notifications = {};
PJQ.views.notifications.NotificationHistory = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-Notification-History'),
		width: 1000,
		maxWidth: '90%'
	},
	events: {
		'click .btn-notification-link': 'copyNotificationLink',
		'click .btn-notification-resend': 'resendNotification'
	},
	afterRender: function () {
		this.dataTable = new PJQ.views.dataTables.DataTable({
			el: '.notifications-data-table',
			data: this.collection.models,
			isHideSearch: true,
			rowId: "cid",
			order: [0, 'desc'],
			language: {
				zeroRecords: 'No notifications have been sent yet'
			},
			// RFI Notifications have extra columns for times sent and last sent, so check if the collection is RFI Notifications
			columns: this.getColumns()
		});
	},
	getColumns: function () {
		if (this.collection instanceof PJQ.collections.rfi.Notifications) {
			return [
				{
					"data": {
						"_": 'attributes.lastSent',
						"display": function (row) {
							return PJQ.helpers.dateHelpers.getDateString(new Date(row.attributes.lastSent), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME, false)
						},
						"filter": function (row) {
							return PJQ.helpers.dateHelpers.getDateString(new Date(row.attributes.lastSent), "MM/dd/yyyy hh:mm:ss TT", false)
						}
					},
					"title": "Last Sent",
					"width": "150px"
				},
				{
					"data": "",
					"title": "Type",
					"width": "20%",
					"render": function (data, type, row) {
						return row.getTypeName();
					}
				},
				{
					"data": "recipient",
					"title": "Recipient",
					"render": function (data) {
						if (data != null) {
							return PJQ.helpers.contacts.getContactAnchor({contact: data});
						}
						return "";
					}
				},
				{
					"data": "attributes.status",
					"title": "Status",
					"width": "80px"
				},
				{
					"data": "attributes.sentCount",
					"title": "Times Sent",
					"width": "40px"
				},
				{
					"data": "",
					"title": "",
					"orderable": false,
					"searchable": false,
					"width": "100px",
					"render": function (data, type, row) {
						let wasResent = row.get('wasResent');

						if (wasResent) {
							return '<div class="text-align-right"><button type="button" title="Copy Link" data-id="' + row.id.toString() + '" class="btn btn-primary btn-notification-link wd-35p ht-30p"><i class="fal fa-link"></i></button><button type="button" title="Resend" data-id="' + row.id.toString() + '" class="btn btn-success btn-notification-resend ml-1 wd-35p ht-30p" disabled><i class="fal fa-check"></i></button></div>';
						} else {
							return '<div class="text-align-right"><button type="button" title="Copy Link" data-id="' + row.id.toString() + '" class="btn btn-primary btn-notification-link wd-35p ht-30p"><i class="fal fa-link"></i></button><button type="button" title="Resend" data-id="' + row.id.toString() + '" class="btn btn-share btn-notification-resend ml-1 wd-35p ht-30p"><i class="fal fa-share"></i></button></div>';
						}
					}
				}
			];
		}

		let cols = [
			{
				"data": {
					"_": 'attributes.createdOn',
					"display": function (row) {
						return PJQ.helpers.dateHelpers.getDateString(new Date(row.attributes.createdOn), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME, false)
					},
					"filter": function (row) {
						return PJQ.helpers.dateHelpers.getDateString(new Date(row.attributes.createdOn), "MM/dd/yyyy hh:mm:ss TT", false)
					}
				},
				"title": "Sent",
				"width": "150px",
				// "render": function (data) {
				// 	return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME);
				// }
			},
			{
				"data": "",
				"title": "Type",
				"width": "20%",
				"render": function (data, type, row) {
					return row.getTypeName();
				}
			},
			{
				"data": "recipient",
				"title": "Recipient",
				"render": function (data) {
					if (data != null) {
						return PJQ.helpers.contacts.getContactAnchor({contact: data});
					}
					return "";
				}
			},
			{
				"data": "attributes.status",
				"title": "Status",
				"width": "80px"
			}
		];

		if (_.size(this.options.extraColumns) > 0) {
			_.each(this.options.extraColumns, (column) => {
				if (column.index == null || column.index >= cols.length - 1) {
					cols.push(column);
					return;
				}

				cols = [
					...cols.slice(0, column.index),
					column,
					...cols.slice(column.index)
				];
			});
		}

		cols.push({
			"data": "",
			"title": "",
			"orderable": false,
			"searchable": false,
			"width": "100px",
			"render": function (data, type, row) {
				return '<div class="text-align-right"><button type="button" title="Copy Link" data-id="' + row.id.toString() + '" class="btn btn-primary btn-notification-link wd-35p ht-30p"><i class="fal fa-link"></i></button><button type="button" title="Resend" data-id="' + row.id.toString() + '" class="btn btn-share btn-notification-resend ml-1 wd-35p ht-30p"><i class="fal fa-share"></i></button></div>';
			}
		});

		return cols;
	},
	copyNotificationLink: function (e) {
		let notificationId = $(e.currentTarget).data('id'),
			notification = this.collection.get(notificationId),
			inputId = 'h_input_' + _.uniqueId(),
			hiddenInput = $('<input>', {
				value: notification.get('url'),
				style: 'position: absolute;left:-2000px;top:-2000px',
				id: inputId
			});
		this.$el.append(hiddenInput);
		hiddenInput[0].select();
		document.execCommand("copy");
		hiddenInput.remove();
	},
	resendNotification: function (e) {
		let resendButton = $(e.currentTarget),
			notificationId = $(e.currentTarget).data('id'),
			notification = this.collection.get(notificationId),
			row = this.dataTable.getRow(notification.cid);
		notification.resend();

		// If the collection is RFI notifications, we want to update the sentCount and the lastSent. Add an attribute "wasResent" to disable the resend button on table redraw.
		if (this.collection instanceof PJQ.collections.rfi.Notifications) {
			notification.set({
				sentCount: notification.get('sentCount') + 1,
				lastSent: new Date(),
				wasResent: true
			});
			row.data(notification).draw();
		} else {
			resendButton.find('i').removeClass('fa-share').addClass('fa-check');
			resendButton.removeClass('btn-share').addClass('btn-success').prop('disabled', true);
		}
	}
});

PJQ.models.notifications = {};
PJQ.models.notifications.Notification = PJQ.models.BaseModel.extend({
	parse: function (model) {
		if (!model)
			return model;

		this.recipient = new PJQ.models.projectContacts.ProjectContact(model.recipient);

		return model;
	},
	getTypeName: function () {
		let name = this.notificationTypeNames[this.get('type')];
		return name || "";
	},
	resend: function () {
		new PJQ.ajax.Request({
			endpoint: this.endpoint() + '/resend'
		}).post().success(_.bind(function (data) {
			PJQ.notifications.notify.successNotify({
				message: 'Notification Resent'
			});
		}, this)).fail(_.bind(function () {
			PJQ.notifications.notify.errorNotify({
				message: 'Encountered an error resending notification.'
			});
		}, this));
	}
});

PJQ.collections.notifications = {};
PJQ.collections.notifications.Notifications = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.notifications.Notification
});
